import React from 'react'
import './Header.scss'
import Logo from '../../assets/imgs/logo_trio_white.svg';
import { Link } from "react-router-dom";

class Header extends React.Component{


    render(){

        return (
            
            <header>
                <div className="container">
                    <img src={Logo} className="logo" />
                </div>
            </header>
                
        )
        
    }
}

export default Header;